/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Online_Faq_A3Inputs */

const en_pc_online_faq_a3 = /** @type {(inputs: Pc_Online_Faq_A3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The app is a single WebAssembly file: about 13 MB compressed, 38 MB uncompressed for version ${i?.version}. Your browser caches it, so later visits open much faster.`)
};

const zh_pc_online_faq_a3 = /** @type {(inputs: Pc_Online_Faq_A3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`应用是一个 WebAssembly 文件：${i?.version} 版压缩后约 13 MB，未压缩为 38 MB。浏览器会缓存它，之后打开会快得多。`)
};

/**
* | output |
* | --- |
* | "The app is a single WebAssembly file: about 13 MB compressed, 38 MB uncompressed for version {version}. Your browser caches it, so later visits open much fas..." |
*
* @param {Pc_Online_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_faq_a3 = /** @type {((inputs: Pc_Online_Faq_A3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Faq_A3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_faq_a3(inputs)
	return zh_pc_online_faq_a3(inputs)
});
export { pc_online_faq_a3 as "pc.online.faq.a3" }